// JavaScript code for sn/share-links component
(($) => {

    "use strict";
    if (! $('.sn-share-links').length) {
        return;
    }
    console.log("sn/share-links scripts loaded...");

    $('a:not(.email)', '.sn-share-links').on('click', function(e) {
        e.preventDefault();
        const url = $(this).attr('href');
        const title = $(this).attr('title');
        window.open(url, title, 'width=600,height=400');
    });

})(jQuery);